import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-js';
import { sources } from 'constants/noc';
import { Autocomplete } from 'components/FormFields';
import { handleShowError, handleError, generateFilterOptions } from 'utils';

const SourcesSelect = ({
  label,
  variant,
  field: { name, value },
  form: { errors, touched, setFieldValue },
  omitFields,
  asyncErrors,
  margin,
}) => {
  const [defaultValue, setDefaultValue] = useState('');
  const filterOptions = generateFilterOptions('start', 'label');
  useEffect(() => {
    if (value || value === '') {
      const defaultVal = sources.find((status) => status === value);

      if (defaultVal) {
        setDefaultValue(defaultVal);
      } else {
        setDefaultValue('');
      }
    }
  }, [value, sources]) // eslint-disable-line

  return (
    <Autocomplete
      openOnFocus
      label={label}
      margin={margin}
      id="noc-sources"
      variant={variant}
      value={defaultValue}
      filterOptions={filterOptions}
      onChange={(ev, val) => setFieldValue(name, val || '')}
      error={handleError(name, errors, touched, asyncErrors)}
      getOptionSelected={(option, value) => option === value || ''}
      options={sources.filter((value) => omitFields.indexOf(value))}
      helperText={handleShowError(name, errors, touched, asyncErrors)}
      getOptionLabel={(option) => (option ? i18n.t(`sources.${option}`) : '')}
    />
  );
};

SourcesSelect.propTypes = {
  label: PropTypes.string,
  asyncErrors: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  field: PropTypes.shape({
    value: PropTypes.any,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
  }),
  style: PropTypes.object,
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
  }),
  omitFields: PropTypes.array,
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
};

SourcesSelect.defaultProps = {
  required: true,
  disabled: false,
  form: {
    errors: {},
    touched: {},
    setFieldValue: () => {},
  },
  style: {},
  field: {},
  omitFields: [],
  label: 'Status',
  variant: 'standard',
};

export default SourcesSelect;
